module.exports = __webpack_public_path__ + "img/Kakao_Pay_KR.95f9a46c.png";